import { render } from "./Example5.vue?vue&type=template&id=710cf98a"
import script from "./Example5.vue?vue&type=script&lang=ts"
export * from "./Example5.vue?vue&type=script&lang=ts"
script.render = render

export default script